import styled from "styled-components";

export const StyledDocument = styled.form`
  height: 1200px;
  overflow-x: hidden;
  overflow-y: auto;
  text-align: justify;

  .proposal-page-sections {
    width: 100%;
  }
`;
